import { SvgIcon, SvgIconProps } from '@mui/material'

const ArrowLeft = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.25 11.996a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.53 5.47a.75.75 0 0 1 0 1.06L7.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06l-6-6a.75.75 0 0 1 0-1.06l6-6a.75.75 0 0 1 1.06 0Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default ArrowLeft
